import { Pipe, PipeTransform } from "@angular/core";
import { CommissionPartyRole } from "../enums/commission-party-role.enum";

@Pipe({ name: "commissionPartyRole" })
export class CommissionPartyRolePipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    switch (value as CommissionPartyRole) {
      case CommissionPartyRole.MobileWalletPLC:
        return "Mobile Wallet PLC";
      case CommissionPartyRole.Partner:
        return "Partner";
      case CommissionPartyRole.Investor:
        return "Investor";
      case CommissionPartyRole.PartnerSubInvestor:
        return "Partner Sub-Investor";
      case CommissionPartyRole.LocationProvider:
        return "Location Provider";
      case CommissionPartyRole.MgmtCompany:
        return "Mgmt Company";
      case CommissionPartyRole.LiquidityProvider:
        return "Liquidity Provider";
      default:
        return value != null ? String(value) : "—";
    }
  }
}
